import React from "react";
import banner1 from "../../../Assets/Banner/superMarket banner-1.jpg";
import banner2 from "../../../Assets/Banner/superMarket banner-2.jpg";

// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// CSS for the component
import "./HeroSection.css";
import "bootstrap/dist/css/bootstrap.min.css";

// Define the component
const HeroSection: React.FC = () => {
  return (
    <div className="carousel-container">
      <Swiper
        spaceBetween={0}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
        effect="fade"
      >
        {[banner1, banner2, banner1, banner2].map((banner: string, index: number) => (
          <SwiperSlide key={index}>
            <img
              src={banner}
              alt={`Slide ${index + 1}`}
              className="carousel-image"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HeroSection;
